import { render } from "./SearchNewsDialog.vue?vue&type=template&id=040f4264&scoped=true"
import script from "./SearchNewsDialog.vue?vue&type=script&lang=js"
export * from "./SearchNewsDialog.vue?vue&type=script&lang=js"

import "./SearchNewsDialog.vue?vue&type=style&index=0&id=040f4264&lang=scss&scoped=true"

import exportComponent from "/Users/ilss0902/PorjectCenter/Cloudmobile/雲端POS_V2/code/pos_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-040f4264"]])

export default __exports__